import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import {
  Box,
  MenuItem,
  Select,
  SelectChangeEvent,
  Tab,
  Tabs,
} from "@mui/material";
import React, { SyntheticEvent, useEffect, useState } from "react";
import SearchBar from "../../components/SearchBar";
import CustomerPendingIssues from "../../features/manageCustomers/customerPendingIssues";
import CustomerOngoingIssues from "../../features/manageCustomers/customerOngoingIssues";
import CustomerCompletedIssues from "../../features/manageCustomers/customerCompletedIssues";
import useTranslation from "../../hooks/traslation";
import { useLazyGetRefundListQuery } from "../../services/refund";
import { RefundData } from "../../types/General";
import { isValidInput } from "../../utils/validations";
import { Refun_Type } from "../../utils/enums";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageIssues = () => {
  const navigate = useNavigate();
  const translation = useTranslation();
  const [searchTerm, setSearchTerm] = useState("");
  const [count, setCount] = useState(0);
  const [rows, setRows] = useState<RefundData[]>([]);
  const [page, setPage] = useState<number>(1);
  const [openDelete, setOpenDelete] = useState(false);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);
  const [getRefundList] = useLazyGetRefundListQuery();
  const [valueTabs, setValueTabs] = useState(0);
  const handleChangeTabs = (event: SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  const [selectField, setSelectField] = React.useState("default");
  const handleChange = (event: SelectChangeEvent) => {
    setSelectField(event.target.value as string);
  };
  const handlePageChange = (event: any, newPage: number) => {
    const updatedPage = newPage + 1;
    setPage(updatedPage);

    const params = new URLSearchParams(window.location.search);
    params.set("page", updatedPage.toString());

    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.pushState({}, "", newUrl);
  };
  const getRefund = async () => {
    setIsLoading(true);
    try {
      const response = await getRefundList({
        page,
        limit: 10,
        search: debouncedSearchTerm.trim(),
        status: valueTabs === 0 ? Refun_Type.PENDING : Refun_Type.COMPLETED,
      }).unwrap();
      if (response?.statusCode === 200) {
        setIsLoading(false);
        setRows(response?.data[0]?.list || []);
        setCount(response?.data[0]?.totalCount);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      getRefund();
    }, 400);
    return () => clearTimeout(timer);
  }, [debouncedSearchTerm, page, valueTabs]);

  return (
    <>
      <MainContainer>
        <div className="main_title">
          <h1>{translation.main.manageRefund}</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>
              {translation.dashboard.dashboard}
            </span>{" "}
            - {translation.main.Refunds}
          </p>
        </div>

        <div className="table_header">
          <div className="left_s">
            <Box className="custom_tabs1" sx={{ width: "100%" }}>
              <Tabs
                value={valueTabs}
                onChange={handleChangeTabs}
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label={translation.main.pendingReq} {...a11yProps(0)} />
                {/* <Tab label="Ongoing Issues" {...a11yProps(1)} /> */}
                <Tab label={translation.main.completedReq} {...a11yProps(1)} />
              </Tabs>
            </Box>
          </div>
        </div>
        <div className="cards">
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  placeholder={translation.user.SearchHere}
                  searchTerm={searchTerm}
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  value={searchTerm}
                  onCross={() => setSearchTerm("")}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                    }
                  }}
                />
              </Box>
            </div>
          </div>
          <CustomTabPanel value={valueTabs} index={0}>
            <CustomerPendingIssues
              rows={rows}
              page={page}
              handleChange={handlePageChange}
              loading={isLoading}
              count={count}
            />
            {rows.length !== 0 && (
              <div className="table_footer">
                <div className="pagination_info">
                  <span className="total_records">Showing {rows.length} of {count} records</span>
                </div>
              </div>
            )}
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={1}>
            <CustomerCompletedIssues
              rows={rows}
              page={page}
              handleChange={handlePageChange}
              loading={isLoading}
              count={count}
            />
            {rows.length !== 0 && (
              <div className="table_footer">
                <div className="pagination_info">
                  <span className="total_records">Showing {rows.length} of {count} records</span>
                </div>
              </div>
            )}
          </CustomTabPanel>
        </div>
      </MainContainer>
    </>
  );
};

export default ManageIssues;
